import { CallRounded } from '@mui/icons-material'
import { useSendForm } from 'feature/productOrder/hooks/useSendForm'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import {
  useGetConsultProductListQuery,
  useUploadConsultationImageMutation,
} from 'feature/productOrder/redux/orders.api'
import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { FC, useEffect, useMemo, useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { Modal } from 'ui'
import { ModalOrderCall } from 'widget/ModalOrderCall/ModalOrderCall'

interface IProductConsultationModal {
  isOpen: boolean
  onClose: () => void
}

export interface ISelectItem {
  id: number
  value: string
  isChild: boolean
  hasChildren: boolean
}

// модальное окно для консультации (Заявка на консультацию)
// (консультация продуктовая)
export const ProductConsultationModal: FC<IProductConsultationModal> = ({
  isOpen,
  onClose,
}) => {
  const [uploadImage] = useUploadConsultationImageMutation()
  const [fileList, setFileList] = useState<orderFormSpace.Images[]>([])
  const { data } = useGetConsultProductListQuery(undefined, { skip: !isOpen })
  const { sendForm, isError } = useSendForm()
  const [isBtnLoading, setBtnLoading] = useState(false)
  const { setConsultationImages } = useActions()

  const images: orderFormSpace.Images[] = useAppSelector(
    state => state.orderForm.consultationForms.consultationProduct.images,
  )

  const selectList = useMemo<ISelectItem[]>(() => {
    if (!data) return []
    return data.list.reduce((result: ISelectItem[], item) => {
      result.push({
        id: item.id,
        value: item.name,
        isChild: false,
        hasChildren: Boolean(item.children),
      })
      if (item.children) {
        item.children.list.forEach(child => {
          result.push({
            id: child.id,
            value: child.name,
            isChild: true,
            hasChildren: false,
          })
        })
      }
      return result
    }, [])
  }, [data])

  const imgDisabled = useMemo(
    () => images.some(img => !img.serverUid),
    [images],
  )

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setBtnLoading(false)
      }, 1000)
    }
  }, [isError])

  const handleSubmitModal = () => {
    setBtnLoading(true)
    sendForm()
    removeModalScrollSafari(false)
  }

  const loadFile = async (file: File) => {
    const ImgData = await uploadImage(file).unwrap()
    return ImgData
  }

  const handleClose = () => {
    setConsultationImages(images.filter(item => item.previewUrl !== null))
    onClose()
  }

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ModalOrderCall
        selectFiled={{
          selectList: selectList,
          selectProps: {
            label: 'Тип продукции',
            required: false,
          },
        }}
        close={handleClose}
        btnLoading={isBtnLoading}
        onSubmit={handleSubmitModal}
        formType={orderFormSpace.ConsultationFormType.consultationProduct}
        fileList={fileList}
        btnDisabled={imgDisabled}
        setFileList={setFileList}
        loadFile={loadFile}
        title='Консультация по сервисному обслуживанию'
        description='У Вас технический вопрос по изделию?
          Оставьте необходимую информацию, и мы с Вами свяжемся!'
        submitButtonText='Заказать звонок'
        SubmitButtonIcon={<CallRounded />}
      />
    </Modal>
  )
}
